import { FC } from "react";
import { PopoverProps } from "@mui/material";
import { CommitmentUtilizationType } from "@/services/cloudchipr.api";
import { DropdownSelectOption } from "@/components/common/select/dropdown-select/utils/types/types";
import { commitmentTypeTitleByType } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/commitment-utilization/utils/constants/constants";
import { FilterTriggerComponentProps } from "@/components/common/select/dropdown-select/utils/types/filterTriggerComponentProps";

import { DropdownSelect } from "@/components/common/select/dropdown-select/DropdownSelect";
import { CommitmentUtilizationTypeSelectTrigger } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/commitment-utilization/components/sidebar/components/CommitmentUtilizationTypeSelectTrigger";

interface CommitmentUtilizationWidgetTypeSelectProps {
  width?: number;
  PopoverProps?: Partial<PopoverProps>;
  commitmentTypes: CommitmentUtilizationType[];
  onChange(value: CommitmentUtilizationType[]): void;
  CustomTriggerComponent?: FC<FilterTriggerComponentProps>;
}

export const CommitmentUtilizationWidgetTypeSelect: FC<
  CommitmentUtilizationWidgetTypeSelectProps
> = ({
  commitmentTypes,
  onChange,
  CustomTriggerComponent,
  PopoverProps,
  width = 200,
}) => {
  return (
    <DropdownSelect
      disableEmptySelectionList
      lastSelectedOptionDisabled
      listWidth={width}
      label="Select Type"
      showSearch={false}
      options={options}
      values={commitmentTypes}
      submitHandlerOnClose={onChange}
      PopoverProps={PopoverProps}
      TriggerComponent={
        CustomTriggerComponent ?? CommitmentUtilizationTypeSelectTrigger
      }
    />
  );
};

const options: DropdownSelectOption[] = [
  {
    value: "savings_plan",
    label: commitmentTypeTitleByType.get("savings_plan"),
    hideOnly: true,
  },
  {
    value: "reservation",
    label: commitmentTypeTitleByType.get("reservation"),
    hideOnly: true,
  },
];
